var abTestingJSON = {
  enableAbTesting: false,
  auto: {
    appRoutes: [
      {
        orderNo: 1,
        label: 'Personal Info',
        moduleName: 'personalinfo',
        subSectionName: 'NameAndDOB',
        path: '/auto/personal-info',
        isSingleScreenView: false,
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'First name',
            controlName: 'firstName',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Last name',
            controlName: 'lastName',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'DOB (mm/dd/yyyy)',
            controlName: 'dateOfBirth',
            tabIndex: '1030',
          },
        ],
      },
      {
        orderNo: 2,
        label: 'Personal Info',
        moduleName: 'personalinfo',
        subSectionName: 'Address',
        path: '/auto/personal-info',
        isSingleScreenView: false,
        formFields: [
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Home address (No PO boxes)',
            controlName: 'address',
            tabIndex: '1040',
          },
          {
            orderNo: '5',
            type: 'text',
            placeholder: 'Unit #',
            controlName: 'apartment',
            tabIndex: '1050',
          },
          {
            orderNo: '6',
            type: 'text',
            placeholder: 'Personalized Message',
            controlName: 'personalizedMessage',
            isFieldHidden: true,
            buttonText: '',
            tabIndex: '1060',
          },
        ],
      },
      {
        orderNo: 3,
        label: 'Vehicle Drivers Review',
        moduleName: 'vehiclesDriversReview',
        path: '/auto/vehicles-drivers-review',
        isSingleScreenView: true,
        subSections: [
          {
            orderNo: 1,
            subSectionName: 'Vehicles',
          },
          {
            orderNo: 2,
            subSectionName: 'Drivers',
          },
        ],
        driverModals: [
          {
            dialogName: 'PNI',
            formFields: [
              {
                orderNo: '1',
                type: 'text',
                placeholder: 'First name',
                controlName: 'firstName',
                tabIndex: '1010',
              },
              {
                orderNo: '2',
                type: 'text',
                placeholder: 'Last name',
                controlName: 'lastName',
                tabIndex: '1020',
              },
              {
                orderNo: '3',
                type: 'text',
                placeholder: 'Date of birth',
                controlName: 'dateOfBirth',
                tabIndex: '1030',
              },
              {
                orderNo: '4',
                type: 'buttonToggle',
                placeholder: 'Please select driver�s gender',
                controlName: 'gender',
                tabIndex: '1040',
                isFieldHidden: false,
              },
              {
                orderNo: '5',
                type: 'radio',
                placeholder:
                  'Is this driver�s license issued by a U.S. state, U.S. territory, or Canadian province?',
                controlName: 'licenseIssued',
                tabIndex: '1050',
              },
              {
                orderNo: '6',
                type: 'radio',
                placeholder: 'Are you currently insured?',
                controlName: 'currentlyInsured',
                tabIndex: '1060',
                isFieldHidden: false,
              },
              {
                orderNo: '7',
                type: 'dropdown',
                placeholder:
                  'What is the reason you are not currently insured?',
                controlName: 'currentlyUninsuredReason',
                tabIndex: '1070',
              },
              {
                orderNo: '8',
                type: 'dropdown',
                placeholder: 'When did your prior policy expire?',
                controlName: 'priorInsuranceExpiredInfo',
                tabIndex: '1080',
                isFieldHidden: false,
              },
              {
                orderNo: '9',
                type: 'text',
                placeholder: 'Current insurance company',
                controlName: 'currentPolicy',
                tabIndex: '1090',
                isFieldHidden: false,
              },
              {
                orderNo: '10',
                type: 'dropdown',
                placeholder: 'Current Bodily Injury (BI) limits',
                controlName: 'policyBILimits',
                tabIndex: '1100',
                isFieldHidden: false,
              },
              {
                orderNo: '11',
                type: 'text',
                placeholder: 'Policy expiration date',
                controlName: 'policyExpiryDate',
                tabIndex: '1110',
                isFieldHidden: false,
              },
              {
                orderNo: '12',
                type: 'dropdown',
                placeholder:
                  'How long have you been continuously insured with this company?',
                controlName: 'insuranceTenure',
                tabIndex: '1120',
              },
              {
                orderNo: '13',
                type: 'text',
                placeholder: 'Prior insurance company',
                controlName: 'priorPolicy',
                tabIndex: '1130',
                isFieldHidden: false,
              },
              {
                orderNo: '14',
                type: 'dropdown',
                placeholder: 'Prior Bodily Injury (BI) limits',
                controlName: 'priorPolicyBILimits',
                tabIndex: '1140',
                isFieldHidden: false,
              },
              {
                orderNo: '15',
                type: 'dropdown',
                placeholder: 'How long were you insured with this company?',
                controlName: 'priorInsuranceTenure',
                tabIndex: '1150',
              },
              {
                orderNo: '16',
                type: 'radio',
                placeholder:
                  'Have you been continuously insured for the past 6 months with any auto insurance company(s)?',
                controlName: 'lastSixMonthsInsuredInfo',
                tabIndex: '1160',
              },
            ],
          },
          {
            dialogName: 'additionalDriver',
            formFields: [
              {
                orderNo: '1',
                type: 'text',
                placeholder: 'First name',
                controlName: 'firstName',
                tabIndex: '1010',
              },
              {
                orderNo: '2',
                type: 'text',
                placeholder: 'Last name',
                controlName: 'lastName',
                tabIndex: '1020',
              },
              {
                orderNo: '3',
                type: 'text',
                placeholder: 'Date of birth',
                controlName: 'dateOfBirth',
                tabIndex: '1030',
              },
              {
                orderNo: '4',
                type: 'buttonToggle',
                placeholder: 'Please select driver�s gender',
                controlName: 'gender',
                tabIndex: '1040',
              },
              {
                orderNo: '5',
                type: 'radio',
                placeholder:
                  'Is this driver�s license issued by a U.S. state, U.S. territory, or Canadian province?',
                controlName: 'licenseIssued',
                tabIndex: '1050',
              },
            ],
          },
        ],
      },
      {
        orderNo: 4,
        label: 'Vehicles',
        moduleName: 'vehicles',
        path: '/auto/vehicles-review',
        formFields: [
          {
            orderNo: '1',
            type: 'buttonToggle',
            placeholder: 'vehicleUsage',
            controlName: 'vehicleUsage',
            tabIndex: '1010',
            isAdpfOrdering: false,
          },
          {
            orderNo: '2',
            type: 'buttonToggle',
            placeholder: 'vehicleOwnership',
            controlName: 'vehicleOwnership',
            tabIndex: '1020',
            isAdpfOrdering: false,
          },
          {
            orderNo: '5',
            type: 'buttonToggle',
            placeholder: 'vehicleParkedAt',
            controlName: 'vehicleParkedAt',
            tabIndex: '1050',
            isAdpfOrdering: false,
          },
          {
            orderNo: '4',
            type: 'buttonToggle',
            placeholder: 'vehicleMilesDriven',
            controlName: 'vehicleMilesDriven',
            tabIndex: '1040',
            isAdpfOrdering: false,
          },
          {
            orderNo: '3',
            type: 'buttonToggle',
            placeholder: 'vehicleAcquired',
            controlName: 'vehicleAcquired',
            tabIndex: '1030',
            isAdpfOrdering: false,
          },
        ],
      },
      {
        orderNo: 5,
        label: 'Drivers',
        moduleName: 'drivers',
        path: '/auto/drivers-review',
        flexFieldsActivePosA: false,
        flexFieldsActivePosB: false,
        splitDriverPage: false,
        driversPerPage: 1,
        isQuestionOrderChanged: false,
        formFields: [
          {
            orderNo: '1',
            type: 'checkbox',
            placeholder: 'Married or domestic partnership',
            controlName: 'maritalStatus',
            tabIndex: '1008',
            isAdpfOrdering: true,
          },
          {
            orderNo: '2',
            type: 'checkbox',
            placeholder: '',
            controlName: 'licenseLessThan3Years',
            tabIndex: '1009',
            isAdpfOrdering: true,
          },
          {
            orderNo: '3',
            type: 'checkbox',
            placeholder: 'Required Financial Responsiblity',
            controlName: 'requiredFinancialResponsiblity',
            tabIndex: '1010',
            isAdpfOrdering: true,
            isFieldHidden: false,
          },
          {
            orderNo: '4',
            type: 'checkbox',
            placeholder: 'Had an accident or violation in last 5 years',
            controlName: 'hadAccidentOrViolation',
            tabIndex: '1011',
            isAdpfDefaultCheckEnabled: false,
            isFieldHidden: false,
          },
          {
            orderNo: '5',
            type: 'buttonToggle',
            placeholder: 'currentlyInsured',
            controlName: 'currentlyInsured',
            tabIndex: '1012',
            isAdpfOrdering: true,
          },
          {
            orderNo: '6',
            type: 'checkbox',
            placeholder: 'fullTimeStudentGPA',
            controlName: 'fullTimeStudentGPA',
            tabIndex: '1013',
            isAdpfOrdering: true,
          },
          {
            orderNo: '7',
            type: 'checkbox',
            placeholder: 'fullTimeAwayatSchool',
            controlName: 'fullTimeAwayatSchool',
            tabIndex: '1014',
            isAdpfOrdering: true,
          },
        ],
      },
      {
        moduleName: 'brightlineToBW',
        brightlineDesign: 'DEFAULT',
      },
      {
        orderNo: 6,
        label: 'Contact Info',
        moduleName: 'contactInfo',
        path: '/auto/contact-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Polict start date',
            controlName: 'policyStartDateDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'checkbox',
            placeholder: 'Save Bundle Sheet',
            controlName: 'saveBundleDiv',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'buttonToggle',
            placeholder: 'Mailing Address',
            controlName: 'mailingAddressDiv',
            tabIndex: '1039',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Contact Deatils',
            controlName: 'contactDetailsDiv',
            tabIndex: '1049',
          },
        ],
      },
      {
        orderNo: 7,
        label: 'Quote',
        moduleName: 'quote',
        path: '/auto/review-quote',
      },
    ],
  },
  home: {
    appRoutes: [
      {
        orderNo: 1,
        label: 'Property Type',
        moduleName: 'propertyType',
        path: '/home/property-type',
      },
      {
        orderNo: 2,
        label: 'Personal Info',
        moduleName: 'personalinfo',
        subSectionName: 'Address',
        path: '/home/personal-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        enableNewTitle: false,
        titleText: 'Whats your address?',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Home address (No PO boxes)',
            controlName: 'address',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Unit #',
            controlName: 'apartment',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'Personalized Message',
            controlName: 'personalizedMessage',
            isFieldHidden: true,
            buttonText: '',
            tabIndex: '1030',
          },
          {
            orderNo: '4',
            type: 'buttonToggle',
            placeholder: 'isNewHome',
            controlName: 'isNewHome',
            tabIndex: '1040',
          },
          {
            orderNo: '5',
            type: 'buttonToggle',
            placeholder: 'isEscrow',
            controlName: 'isEscrow',
            tabIndex: '1050',
          },
          {
            orderNo: '6',
            type: 'buttonToggle',
            placeholder: 'isPrimaryResidence',
            controlName: 'isPrimaryResidence',
            tabIndex: '1060',
          },
          {
            orderNo: '7',
            type: 'radio',
            placeholder: 'notPrimaryResidenceReason',
            controlName: 'notPrimaryResidenceReason',
            tabIndex: '1070',
          },
          {
            orderNo: '8',
            type: 'buttonToggle',
            placeholder: 'noOfPropertyLosses',
            controlName: 'noOfPropertyLosses',
            tabIndex: '1080',
          },
        ],
      },
      {
        orderNo: 3,
        label: 'Property Details',
        moduleName: 'propertyDetails',
        path: '/home/property-details',
        subSectionName: 'PropertyDetails',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Property Details Header',
            controlName: 'propertyDeatilsHeader',
            enableHeaderChange: false,
            headerText: '',
            tabIndex: '1130',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Property Details SubHeader',
            controlName: 'propertyDeatilsSubHeader',
            enableHeaderChange: false,
            subHeaderText: 'Home property details',
            tabIndex: '1230',
          },
          {
            orderNo: '3',
            type: 'image',
            placeholder: 'Property Details Grade Image',
            controlName: 'property_gradeImage',
            showPropertyGradeImage: false,
            tabIndex: '1330',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Property Details List',
            controlName: 'propertyDetailsList',
            propertyDeatilsOrdering: false,
            propertyDeatilsChangeTitle: false,
            propertyDetailsChangeDescription: false,
            tabIndex: '1430',
            formFields: [
              {
                orderNo: '3',
                type: 'text',
                placeholder: 'Year built',
                controlName: '0',
                alternateDescription: 'alternate description for Year Built',
                alternateName: 'Construction Date (Year built)',
              },
              {
                orderNo: '2',
                type: 'text',
                placeholder: 'Total sq. ft',
                controlName: '1',
                alternateDescription: 'alternate description for Total sq. ft'
              },
              {
                orderNo: '1',
                type: 'text',
                placeholder: 'Stories',
                controlName: '2',
                alternateName: 'Floors (Stories)',
                alternateDescription: 'alternate description for Stories'
              },
              {
                orderNo: '4',
                type: 'text',
                placeholder: 'Bathrooms',
                controlName: '3',
              },
              {
                orderNo: '5',
                type: 'text',
                placeholder: 'Fireplace',
                controlName: '4',
              },
              {
                orderNo: '6',
                type: 'text',
                placeholder: 'Floors',
                controlName: '5',
              },
              {
                orderNo: '7',
                type: 'text',
                placeholder: 'Garage style',
                controlName: '6',
              },
              {
                orderNo: '8',
                type: 'text',
                placeholder: 'Garage / carport',
                controlName: '7',
              },
              {
                orderNo: '9',
                type: 'text',
                placeholder: 'Exterior wall finish',
                controlName: '8',
              },
              {
                orderNo: '10',
                type: 'text',
                placeholder: 'Foundation type',
                controlName: '9',
              },
              {
                orderNo: '11',
                type: 'text',
                placeholder: 'Roof cover',
                controlName: '10',
              },
              {
                orderNo: '12',
                type: 'text',
                placeholder: 'Type of home',
                controlName: '11',
              },
            ],
          },{
            orderNo: '5',
            type: 'text',
            showPropertyType: true            
          },
          {
            orderNo: '6',
            type: 'button',
            placeholder: 'Continue',
            controlName: 'CTAButtonName',
            changeCTAButtonName: false,
            alternateName : 'Continue for AB test',
            tabIndex: '1330',
          },
        ],
      },
      {
        orderNo: 4,
        label: 'Additional Info',
        moduleName: 'additionalHome',
        path: '/home/additional-info',
        buttonText: '',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Do Any Apply',
            controlName: 'doAnyApplyDiv',
            tabIndex: '1010',
            subSections: [
              {
                orderNo: '1',
                controlName: 'doAnyApplyHeading',
                placeholder: '',
              },
              {
                orderNo: '2',
                controlName: 'tempRental',
              },
              {
                orderNo: '3',
                controlName: 'homeLob',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'swimmingPool',
                  },
                  {
                    orderNo: '2',
                    controlName: 'solarPanels',
                  },
                  {
                    orderNo: '3',
                    controlName: 'trampoline',
                  },
                  {
                    orderNo: '4',
                    controlName: 'roofCoverage',
                  },
                  {
                    orderNo: '5',
                    controlName: 'basementQuestion',
                  }
                ],
              },
              {
                orderNo:'4',
                controlName: 'doAnyDivider'
              },
            ]
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Additional Discounts',
            controlName: 'additionalDiscountsDiv',
            tabIndex: '1020',
            subSections: [
              {
                orderNo: '1',
                controlName: 'headingDiscountDiv',
                placeholder: '',
              },
              {
                orderNo: '2',
                controlName: 'homeDiscountsDiv',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'fireAlarmDiscount',
                  },
                  {
                    orderNo: '2',
                    controlName: 'burglarAlarmDiscount',
                  },
                  {
                    orderNo: '3',
                    controlName: 'waterLeakDiscount',
                  },
                  {
                    orderNo: '4',
                    controlName: 'fortifiedHomeDiscount',
                  },
                ],
              },
              {
                orderNo: '3',
                controlName: 'condoDiscounts',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'centralFireDiscount',
                  },
                  {
                    orderNo: '2',
                    controlName: 'centralBurglarDiscount',
                  },
                ],
              },
              {
                orderNo: '4',
                controlName: 'additionalDiscountsDivider',
              },
            ]
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'Home Discounts',
            controlName: 'globalDiscountsDiv',
            tabIndex: '1030',
          },
        ],
      },
      {
        orderNo: 5,
        label: 'About You',
        moduleName: 'aboutYou',
        path: '/home/about-you',
        buttonText: '',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Name and Dob',
            controlName: 'personalInfoDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Occupation',
            controlName: 'occupationDiv',
            buttonText: '',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'checkbox',
            placeholder: 'Spouse Details',
            controlName: 'spouseDetailsDiv',
            tabIndex: '1030',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Prior Current Address',
            controlName: 'priorCurrentAddress',
            tabIndex: '1040',
          },
          {
            orderNo: '5',
            type: 'text',
            placeholder: 'Applied Discounts',
            controlName: 'appliedDiscountsDiv',
            tabIndex: '1050',
          },
        ],
      },
      {
        orderNo: 6,
        label: 'Contact Info',
        moduleName: 'contactInfo',
        path: '/home/contact-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Polict start date',
            controlName: 'policyStartDateDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'checkbox',
            placeholder: 'Save Bundle Sheet',
            controlName: 'saveBundleDiv',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'buttonToggle',
            placeholder: 'Mailing Address',
            controlName: 'mailingAddressDiv',
            tabIndex: '1039',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Contact Deatils',
            controlName: 'contactDetailsDiv',
            tabIndex: '1049',
          },
        ],
      },
      {
        orderNo: 7,
        label: 'Dwelling Coverage',
        moduleName: 'dwellingCoverage',
        path: 'home/dwelling-coverage',
        titleText: '',
        buttonText: '',
        imagePath: '',
        contentDescription: '',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'dwelling coverage info',
            controlName: 'dwellingCoverageInfoDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'property grade',
            controlName: 'propertyGradeDiv',
            isFieldHidden: false,
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'dwelling disclaimer',
            controlName: 'dwellingDisclaimer',
            tabIndex: '1030',
            subSections: [
              {
                orderNo: '1',
                controlName: 'replacementCostDiscDiv',
              },
              {
                orderNo: '2',
                controlName: 'questionSpacing',
              },
              {
                orderNo: '3',
                controlName: 'dwellingEstimateDiv',
              },
            ]
          },
        ]
      }
    ],
  },
  business: {
    appRoutes: [],
  },
  life: {
    appRoutes: [],
  },
  renters: {
    appRoutes: [
      {
        orderNo: 1,
        label: 'Property Type',
        moduleName: 'propertyType',
        path: '/home/property-type',
      },
      {
        orderNo: 2,
        label: 'Personal Info',
        moduleName: 'personalinfo',
        subSectionName: 'Address',
        path: '/home/personal-info',
        disclaimerMatch: false,
        enableNewTitle: false,
        titleText: 'Whats your address',
        buttonText: 'Agree and submit',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Home address (No PO boxes)',
            controlName: 'address',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Unit #',
            controlName: 'apartment',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'Personalized Message',
            controlName: 'personalizedMessage',
            isFieldHidden: true,
            buttonText: '',
            tabIndex: '1030',
          },
          {
            orderNo: '4',
            type: 'buttonToggle',
            placeholder: 'noOfPropertyLosses',
            controlName: 'noOfPropertyLosses',
            tabIndex: '1040',
          },
        ],
      },
      {
        orderNo: 3,
        label: 'About You',
        moduleName: 'aboutYou',
        path: '/home/about-you',
        buttonText: '',
        formFields: [{}],
      },
      {
        orderNo: 4,
        label: 'Contact Info',
        moduleName: 'contactInfo',
        path: '/home/contact-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Polict start date',
            controlName: 'policyStartDateDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'checkbox',
            placeholder: 'Save Bundle Sheet',
            controlName: 'saveBundleDiv',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'buttonToggle',
            placeholder: 'Mailing Address',
            controlName: 'mailingAddressDiv',
            tabIndex: '1039',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Contact Deatils',
            controlName: 'contactDetailsDiv',
            tabIndex: '1049',
          },
        ],
      },
      {
        orderNo: 5,
        label: 'Quote',
        moduleName: 'quote',
        path: '/home/renters/review-quote',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Here is your quote',
            controlName: 'heading-section',
            enableHeaderChange: false,
            headerText: 'Here is your quote for AB',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'button',
            placeholder: 'Continue',
            controlName: 'right-sidebar',
            enableButtonChange: false,
            buttonText: 'Continue for AB',
            tabIndex: '1010',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'PaymentMode',
            controlName: 'right-sidebar',
            enableTextChange: false,
            paymentModeText: 'EFT',
            tabIndex: '1010',
          },
        ]
      },
    ],
  },
  condo: {
    appRoutes: [
      {
        orderNo: 1,
        label: 'Personal Info',
        moduleName: 'personalinfo',
        subSectionName: 'Address',
        path: '/home/personal-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        enableNewTitle: false,
        titleText: 'Whats your address',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Home address (No PO boxes)',
            controlName: 'address',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Unit #',
            controlName: 'apartment',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'Personalized Message',
            controlName: 'personalizedMessage',
            isFieldHidden: true,
            buttonText: '',
            tabIndex: '1030',
          },
          {
            orderNo: '4',
            type: 'buttonToggle',
            placeholder: 'isNewHome',
            controlName: 'isNewHome',
            tabIndex: '1040',
          },
          {
            orderNo: '5',
            type: 'buttonToggle',
            placeholder: 'isEscrow',
            controlName: 'isEscrow',
            tabIndex: '1050',
          },
          {
            orderNo: '6',
            type: 'buttonToggle',
            placeholder: 'isPrimaryResidence',
            controlName: 'isPrimaryResidence',
            tabIndex: '1060',
          },
          {
            orderNo: '7',
            type: 'radio',
            placeholder: 'notPrimaryResidenceReason',
            controlName: 'notPrimaryResidenceReason',
            tabIndex: '1070',
          },
          {
            orderNo: '8',
            type: 'buttonToggle',
            placeholder: 'HOACoversWallsIn',
            controlName: 'HOACoversWallsIn',
            tabIndex: '1080',
          },
          {
            orderNo: '9',
            type: 'buttonToggle',
            placeholder: 'noOfPropertyLosses',
            controlName: 'noOfPropertyLosses',
            tabIndex: '1090',
          },
        ],
      },
      {
        orderNo: 2,
        label: 'Property Details',
        moduleName: 'propertyDetails',
        path: '/home/property-details',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Property Details Header',
            controlName: 'propertyDeatilsHeader',
            enableHeaderChange: false,
            headerText: 'What we know so far',
            tabIndex: '1130',
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Property Details SubHeader',
            controlName: 'propertyDeatilsSubHeader',
            enableHeaderChange: false,
            subHeaderText: 'Home property details',
            tabIndex: '1230',
          },
          {
            orderNo: '3',
            type: 'image',
            placeholder: 'Property Details Grade Image',
            controlName: 'property_gradeImage',
            showPropertyGradeImage: false,
            tabIndex: '1330',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Property Details List',
            controlName: 'propertyDetailsList',
            propertyDeatilsOrdering: false,
            propertyDeatilsChangeTitle: false,
            propertyDetailsChangeDescription: false,
            tabIndex: '1430',
            formFields: [
              {
                orderNo: '3',
                type: 'text',
                placeholder: 'Year built',
                controlName: '0',
                alternateDescription: 'alternate description for Year Built',
                alternateName: 'Construction Date (Year built)',
              },
              {
                orderNo: '2',
                type: 'text',
                placeholder: 'Total sq. ft',
                controlName: '1',
                alternateDescription: 'alternate description for Total sq. ft'
              },
              {
                orderNo: '1',
                type: 'text',
                placeholder: 'Stories',
                controlName: '2',
                alternateName: 'Floors (Stories)',
                alternateDescription: 'alternate description for Stories'
              },
              {
                orderNo: '4',
                type: 'text',
                placeholder: 'Bathrooms',
                controlName: '3',
              },
              {
                orderNo: '5',
                type: 'text',
                placeholder: 'Fireplace',
                controlName: '4',
              },
              {
                orderNo: '6',
                type: 'text',
                placeholder: 'Floors',
                controlName: '5',
                formFields: [
                  {
                    orderNo: '4',
                    type: 'text',
                    placeholder: 'Carpet',
                    controlName: '1',
                  },
                  {
                    orderNo: '2',
                    type: 'text',
                    placeholder: 'Hardwood',
                    controlName: '2',
                  },
                  {
                    orderNo: '3',
                    type: 'text',
                    placeholder: 'Laminate',
                    controlName: '3',
                  },
                  {
                    orderNo: '1',
                    type: 'text',
                    placeholder: 'Vinyl',
                    controlName: '4',
                  },
                  {
                    orderNo: '5',
                    type: 'text',
                    placeholder: 'Linoleum',
                    controlName: '5',
                  },
                  {
                    orderNo: '6',
                    type: 'text',
                    placeholder: 'Stone & tile',
                    controlName: '6',
                  },
                ]
              },
              {
                orderNo: '7',
                type: 'text',
                placeholder: 'Garage style',
                controlName: '6',
              },
              {
                orderNo: '8',
                type: 'text',
                placeholder: 'Garage / carport',
                controlName: '7',
              },
            ],
          },
          {
            orderNo: '5',
            type: 'button',
            placeholder: 'Continue',
            controlName: 'CTAButtonName',
            changeCTAButtonName: false,
            alternateName : 'Continue for AB test',
            tabIndex: '1330',
          },
        ],
      },
      {
        orderNo: 3,
        label: 'Additional Info',
        moduleName: 'additionalHome',
        path: '/home/additional-info',
        buttonText: '',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Do Any Apply',
            controlName: 'doAnyApplyDiv',
            tabIndex: '1010',
            subSections: [
              {
                orderNo: '1',
                controlName: 'doAnyApplyHeading',
                placeholder: '',
              },
              {
                orderNo: '2',
                controlName: 'tempRental',
              },
              {
                orderNo: '3',
                controlName: 'homeLob',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'swimmingPool',
                  },
                  {
                    orderNo: '2',
                    controlName: 'solarPanels',
                  },
                  {
                    orderNo: '3',
                    controlName: 'trampoline',
                  },
                  {
                    orderNo: '4',
                    controlName: 'roofCoverage',
                  },
                  {
                    orderNo: '5',
                    controlName: 'basementQuestion',
                  }
                ],
              },
              {
                orderNo:'4',
                controlName: 'doAnyDivider'
              },
            ]
          },
          {
            orderNo: '2',
            type: 'text',
            placeholder: 'Additional Discounts',
            controlName: 'additionalDiscountsDiv',
            tabIndex: '1020',
            subSections: [
              {
                orderNo: '1',
                controlName: 'headingDiscountDiv',
                placeholder: '',
              },
              {
                orderNo: '2',
                controlName: 'homeDiscountsDiv',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'fireAlarmDiscount',
                  },
                  {
                    orderNo: '2',
                    controlName: 'burglarAlarmDiscount',
                  },
                  {
                    orderNo: '3',
                    controlName: 'waterLeakDiscount',
                  },
                  {
                    orderNo: '4',
                    controlName: 'fortifiedHomeDiscount',
                  },
                ],
              },
              {
                orderNo: '3',
                controlName: 'condoDiscounts',
                subSections: [
                  {
                    orderNo: '1',
                    controlName: 'centralFireDiscount',
                  },
                  {
                    orderNo: '2',
                    controlName: 'centralBurglarDiscount',
                  },
                ],
              },
              {
                orderNo: '4',
                controlName: 'additionalDiscountsDivider',
              },
            ]
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'Home Discounts',
            controlName: 'globalDiscountsDiv',
            tabIndex: '1030',
          },
        ],
      },
      {
        orderNo: 4,
        label: 'About You',
        moduleName: 'aboutYou',
        path: '/home/about-you',
        buttonText: '',
        formFields: [{}],
      },
      {
        orderNo: 5,
        label: 'Contact Info',
        moduleName: 'contactInfo',
        path: '/home/contact-info',
        disclaimerMatch: false,
        buttonText: 'Agree and submit',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Polict start date',
            controlName: 'policyStartDateDiv',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'checkbox',
            placeholder: 'Save Bundle Sheet',
            controlName: 'saveBundleDiv',
            tabIndex: '1020',
          },
          {
            orderNo: '3',
            type: 'buttonToggle',
            placeholder: 'Mailing Address',
            controlName: 'mailingAddressDiv',
            tabIndex: '1039',
          },
          {
            orderNo: '4',
            type: 'text',
            placeholder: 'Contact Deatils',
            controlName: 'contactDetailsDiv',
            tabIndex: '1049',
          },
        ],
      },
      {
        orderNo: 6,
        label: 'Quote',
        moduleName: 'quote',
        path: '/home/condo/review-quote',
        formFields: [
          {
            orderNo: '1',
            type: 'text',
            placeholder: 'Here is your quote',
            controlName: 'heading-section',
            enableHeaderChange: false,
            headerText: 'Here is your quote for AB',
            tabIndex: '1010',
          },
          {
            orderNo: '2',
            type: 'button',
            placeholder: 'Continue',
            controlName: 'right-sidebar',
            enableButtonChange: false,
            buttonText: 'Continue for AB',
            tabIndex: '1010',
          },
          {
            orderNo: '3',
            type: 'text',
            placeholder: 'PaymentMode',
            controlName: 'right-sidebar',
            enableTextChange: false,
            paymentModeText: 'EFT',
            tabIndex: '1010',
          },
        ]
      },
    ],
  },
};
